import { Vue } from 'vue-property-decorator'
import InputBasico from './InputBasico'
import axios from 'axios'
import StringMask from '@/utils/StringMask'

export interface IViaCepObject {
	cep: string
	logradouro: string
	localidade: string
	complemento: string
	bairro: string
	uf: string
	ddd: string
	siafi: string
	erro?: boolean
}

export const InputCEP = Vue.extend({
	name: 'InputCEP',
	props: {
		value: { type: String },
		required: { type: Boolean },
		persistentPlaceholder: { default: true }
	},

	data: () => ({
		internalValue: '',
		isValid: true,
		rules: new Array<any>(),
		isLoading: false,
		address: {}
	}),

	mounted() {
		if (this.value) {
			this.internalValue = this.value
			this.handleInput()
		}
		this.rules = [(v: string) => this.isValid || 'CEP Inválido']
	},

	render() {
		return (
			<InputBasico
				{...{ attrs: this.$attrs }}
				vModel={this.internalValue}
				on={{
					input: this.handleInput
				}}
				type="phone"
				label="CEP"
				rules={this.rules}
				placeholder="00000-000"
				persistent-placeholder={this.persistentPlaceholder}
				loading={this.isLoading}
			/>
		)
	},

	methods: {
		/*
		 * Evento disparado quando o valor do input é alterado
		 * @memberof InputCEP
		 * @method handleInput
		 */
		handleInput() {
			const result = this.applyMask()

			this.$emit('input', result.maskedValue)
			this.$emit('inputUnmasked', result.unmaskedValue)

			this.getAddress()
		},

		applyMask() {
			const mask = new StringMask({ mask: '00000-000' })
			const result = mask.apply(this.internalValue)

			this.internalValue = result.maskedValue

			return result
		},

		/*
		 * Get address from CEP
		 */
		async getAddress() {
			if (!this.internalValue || this.internalValue.length < 9) return

			this.isLoading = true

			try {
				this.isValid = true

				let endpoint = `https://viacep.com.br/ws/${this.internalValue}/json/`
				let response = await axios.get<IViaCepObject>(endpoint)

				const result = response.data

				if (result.erro != undefined) {
					this.isValid = false
					this.isLoading = false
					return
				}

				this.$emit('address', result)
			} catch {
				this.isValid = false
			}

			this.isLoading = false
			return
		}
	},

	watch: {
		value(v: string) {
			this.handleInput()
		}
	}
})

export default InputCEP
